import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import Home from './pages/Home'

function App() {
  useEffect(() => {
    // Detectar e redirecionar URLs com hash para URLs sem hash
    const hash = window.location.hash;
    
    if (hash && hash.startsWith('#/')) {
      // Remove o # e usa o restante como pathname
      const pathWithoutHash = hash.substring(1); // Remove o #
      const newUrl = window.location.origin + pathWithoutHash + window.location.search;
      
      console.log('[App] Redirecting from hash URL:', window.location.href, 'to:', newUrl);
      window.location.replace(newUrl);
      return;
    }
    
    console.log('[App Debug] Initial href:', window.location.href);
    console.log('[App Debug] Initial pathname:', window.location.pathname);
    console.log('[App Debug] Initial search/hash:', window.location.search, window.location.hash);
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  )
}

export default App
